import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ROUTE_PATHS } from 'utils/constants/index'

const useGameMaintenanceCheck = (defaultGameId) => {
  const history = useHistory()
  const { search } = useLocation()
  const { systemGameData } = useSelector((state) => state.gameSetting)
  const gameId = new URLSearchParams(search).get('gameId') || defaultGameId

  useEffect(() => {
    if (!systemGameData?.length || !gameId) return

    systemGameData.forEach((settings) => {
      if (settings.gameId === +gameId && (settings.isActive === false || settings.maintenanceMode === true)) {
        history.push(ROUTE_PATHS.error, { settings })
      }
    })
  }, [systemGameData, gameId, history])
}

export default useGameMaintenanceCheck
